export default "__VITE_ASSET__789f8de1__"